import { render, staticRenderFns } from "./ZeroEnrolleeFacilities.vue?vue&type=template&id=2aa6b684&scoped=true&"
import script from "./ZeroEnrolleeFacilities.vue?vue&type=script&lang=js&"
export * from "./ZeroEnrolleeFacilities.vue?vue&type=script&lang=js&"
import style0 from "./ZeroEnrolleeFacilities.vue?vue&type=style&index=0&id=2aa6b684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6b684",
  null
  
)

export default component.exports